/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminDebitOrCreditFuelRequestBody,
  ApiError,
  FuelPurchase,
  FuelPurchaseRequestBody,
  GetFuelPriceResponse,
  GetFuelPurchasesResponse,
  GetTotalFuelResponse,
  GetTransactionsPaginatedResponse,
  GetTransactionsPaginatedSort,
  GetTransactionsResponse,
  GetTransactionsSort,
  SortOrder,
  SubmitFuelPurchaseResponse,
  VerifyFuelPurchaseResponse,
} from '../models/index';
import {
    AdminDebitOrCreditFuelRequestBodyFromJSON,
    AdminDebitOrCreditFuelRequestBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    FuelPurchaseFromJSON,
    FuelPurchaseToJSON,
    FuelPurchaseRequestBodyFromJSON,
    FuelPurchaseRequestBodyToJSON,
    GetFuelPriceResponseFromJSON,
    GetFuelPriceResponseToJSON,
    GetFuelPurchasesResponseFromJSON,
    GetFuelPurchasesResponseToJSON,
    GetTotalFuelResponseFromJSON,
    GetTotalFuelResponseToJSON,
    GetTransactionsPaginatedResponseFromJSON,
    GetTransactionsPaginatedResponseToJSON,
    GetTransactionsPaginatedSortFromJSON,
    GetTransactionsPaginatedSortToJSON,
    GetTransactionsResponseFromJSON,
    GetTransactionsResponseToJSON,
    GetTransactionsSortFromJSON,
    GetTransactionsSortToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    SubmitFuelPurchaseResponseFromJSON,
    SubmitFuelPurchaseResponseToJSON,
    VerifyFuelPurchaseResponseFromJSON,
    VerifyFuelPurchaseResponseToJSON,
} from '../models/index';

export interface CreateTransactionsAdminDebitOrCreditFuelRequest {
    adminDebitOrCreditFuelRequestBody?: AdminDebitOrCreditFuelRequestBody;
}

export interface CreateTransactionsFuelPurchaseIdRequest {
    id: string;
    body?: object;
}

export interface GetTransactionsFuelPurchaseIdVerifyRequest {
    id: string;
}

export interface GetTransactionsFuelPurchasesRequest {
    search?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetTransactionsIdRequest {
    id: string;
    sort?: GetTransactionsSort;
    order?: SortOrder;
}

export interface GetTransactionsIndustryCollectionPayoutsReportRequest {
    month?: string;
    year?: string;
}

export interface GetTransactionsPaginatedIdRequest {
    id: string;
    sort?: GetTransactionsPaginatedSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
}

export interface UpdateTransactionsFuelPurchasesRequest {
    fuelPurchaseRequestBody?: FuelPurchaseRequestBody;
}

/**
 * TransactionsApi - interface
 * 
 * @export
 * @interface TransactionsApiInterface
 */
export interface TransactionsApiInterface {
    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel
     * @param {AdminDebitOrCreditFuelRequestBody} [adminDebitOrCreditFuelRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    createTransactionsAdminDebitOrCreditFuelRaw(requestParameters: CreateTransactionsAdminDebitOrCreditFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel
     */
    createTransactionsAdminDebitOrCreditFuel(requestParameters: CreateTransactionsAdminDebitOrCreditFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to purchase token with fiat
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    createTransactionsFuelPurchaseIdRaw(requestParameters: CreateTransactionsFuelPurchaseIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitFuelPurchaseResponse>>;

    /**
     * Used to purchase token with fiat
     */
    createTransactionsFuelPurchaseId(requestParameters: CreateTransactionsFuelPurchaseIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitFuelPurchaseResponse>;

    /**
     * Gets the current price of Fuel in USD.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsFuelPriceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelPriceResponse>>;

    /**
     * Gets the current price of Fuel in USD.
     */
    getTransactionsFuelPrice(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelPriceResponse>;

    /**
     * Verify that the payment has been successfully processed and gives tokens to customer.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsFuelPurchaseIdVerifyRaw(requestParameters: GetTransactionsFuelPurchaseIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyFuelPurchaseResponse>>;

    /**
     * Verify that the payment has been successfully processed and gives tokens to customer.
     */
    getTransactionsFuelPurchaseIdVerify(requestParameters: GetTransactionsFuelPurchaseIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyFuelPurchaseResponse>;

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsFuelPurchasesRaw(requestParameters: GetTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelPurchasesResponse>>;

    /**
     */
    getTransactionsFuelPurchases(requestParameters: GetTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelPurchasesResponse>;

    /**
     * Get total FIAT FUEL amount of all existing users (in FUEL and in USD)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsGetTotalFuelAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTotalFuelResponse>>;

    /**
     * Get total FIAT FUEL amount of all existing users (in FUEL and in USD)
     */
    getTransactionsGetTotalFuelAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTotalFuelResponse>;

    /**
     * Used by users to get their current fuel balance and transactions stored on their account
     * @param {string} id 
     * @param {GetTransactionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsIdRaw(requestParameters: GetTransactionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionsResponse>>;

    /**
     * Used by users to get their current fuel balance and transactions stored on their account
     */
    getTransactionsId(requestParameters: GetTransactionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionsResponse>;

    /**
     * Will generate a report of all the industry collection payouts for a given month and year.
     * @param {string} [month] 
     * @param {string} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsIndustryCollectionPayoutsReportRaw(requestParameters: GetTransactionsIndustryCollectionPayoutsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Will generate a report of all the industry collection payouts for a given month and year.
     */
    getTransactionsIndustryCollectionPayoutsReport(requestParameters: GetTransactionsIndustryCollectionPayoutsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Used by users to get their current fuel balance and paginated transactions stored on their account
     * @param {string} id 
     * @param {GetTransactionsPaginatedSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    getTransactionsPaginatedIdRaw(requestParameters: GetTransactionsPaginatedIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionsPaginatedResponse>>;

    /**
     * Used by users to get their current fuel balance and paginated transactions stored on their account
     */
    getTransactionsPaginatedId(requestParameters: GetTransactionsPaginatedIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionsPaginatedResponse>;

    /**
     * Creates or updates a new price quote for FUEL purchase.
     * @param {FuelPurchaseRequestBody} [fuelPurchaseRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApiInterface
     */
    updateTransactionsFuelPurchasesRaw(requestParameters: UpdateTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelPurchase>>;

    /**
     * Creates or updates a new price quote for FUEL purchase.
     */
    updateTransactionsFuelPurchases(requestParameters: UpdateTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelPurchase>;

}

/**
 * 
 */
export class TransactionsApi extends runtime.BaseAPI implements TransactionsApiInterface {

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel
     */
    async createTransactionsAdminDebitOrCreditFuelRaw(requestParameters: CreateTransactionsAdminDebitOrCreditFuelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("GodAdmin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/admin-debit-or-credit-fuel`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminDebitOrCreditFuelRequestBodyToJSON(requestParameters['adminDebitOrCreditFuelRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Allows an admin to debit or credit an arbitrary amount of fuel
     */
    async createTransactionsAdminDebitOrCreditFuel(requestParameters: CreateTransactionsAdminDebitOrCreditFuelRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTransactionsAdminDebitOrCreditFuelRaw(requestParameters, initOverrides);
    }

    /**
     * Used to purchase token with fiat
     */
    async createTransactionsFuelPurchaseIdRaw(requestParameters: CreateTransactionsFuelPurchaseIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitFuelPurchaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTransactionsFuelPurchaseId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/fuel-purchase/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitFuelPurchaseResponseFromJSON(jsonValue));
    }

    /**
     * Used to purchase token with fiat
     */
    async createTransactionsFuelPurchaseId(requestParameters: CreateTransactionsFuelPurchaseIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitFuelPurchaseResponse> {
        const response = await this.createTransactionsFuelPurchaseIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the current price of Fuel in USD.
     */
    async getTransactionsFuelPriceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelPriceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/transactions/fuel-price`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFuelPriceResponseFromJSON(jsonValue));
    }

    /**
     * Gets the current price of Fuel in USD.
     */
    async getTransactionsFuelPrice(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelPriceResponse> {
        const response = await this.getTransactionsFuelPriceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Verify that the payment has been successfully processed and gives tokens to customer.
     */
    async getTransactionsFuelPurchaseIdVerifyRaw(requestParameters: GetTransactionsFuelPurchaseIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyFuelPurchaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTransactionsFuelPurchaseIdVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/fuel-purchase/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyFuelPurchaseResponseFromJSON(jsonValue));
    }

    /**
     * Verify that the payment has been successfully processed and gives tokens to customer.
     */
    async getTransactionsFuelPurchaseIdVerify(requestParameters: GetTransactionsFuelPurchaseIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyFuelPurchaseResponse> {
        const response = await this.getTransactionsFuelPurchaseIdVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTransactionsFuelPurchasesRaw(requestParameters: GetTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFuelPurchasesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/fuel-purchases`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFuelPurchasesResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTransactionsFuelPurchases(requestParameters: GetTransactionsFuelPurchasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFuelPurchasesResponse> {
        const response = await this.getTransactionsFuelPurchasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total FIAT FUEL amount of all existing users (in FUEL and in USD)
     */
    async getTransactionsGetTotalFuelAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTotalFuelResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/get-total-fuel-all-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTotalFuelResponseFromJSON(jsonValue));
    }

    /**
     * Get total FIAT FUEL amount of all existing users (in FUEL and in USD)
     */
    async getTransactionsGetTotalFuelAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTotalFuelResponse> {
        const response = await this.getTransactionsGetTotalFuelAllUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used by users to get their current fuel balance and transactions stored on their account
     */
    async getTransactionsIdRaw(requestParameters: GetTransactionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTransactionsId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTransactionsResponseFromJSON(jsonValue));
    }

    /**
     * Used by users to get their current fuel balance and transactions stored on their account
     */
    async getTransactionsId(requestParameters: GetTransactionsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionsResponse> {
        const response = await this.getTransactionsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Will generate a report of all the industry collection payouts for a given month and year.
     */
    async getTransactionsIndustryCollectionPayoutsReportRaw(requestParameters: GetTransactionsIndustryCollectionPayoutsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/industry_collection_payouts_report`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Will generate a report of all the industry collection payouts for a given month and year.
     */
    async getTransactionsIndustryCollectionPayoutsReport(requestParameters: GetTransactionsIndustryCollectionPayoutsReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getTransactionsIndustryCollectionPayoutsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used by users to get their current fuel balance and paginated transactions stored on their account
     */
    async getTransactionsPaginatedIdRaw(requestParameters: GetTransactionsPaginatedIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionsPaginatedResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTransactionsPaginatedId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions-paginated/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTransactionsPaginatedResponseFromJSON(jsonValue));
    }

    /**
     * Used by users to get their current fuel balance and paginated transactions stored on their account
     */
    async getTransactionsPaginatedId(requestParameters: GetTransactionsPaginatedIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionsPaginatedResponse> {
        const response = await this.getTransactionsPaginatedIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a new price quote for FUEL purchase.
     */
    async updateTransactionsFuelPurchasesRaw(requestParameters: UpdateTransactionsFuelPurchasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FuelPurchase>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/transactions/fuel-purchases`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FuelPurchaseRequestBodyToJSON(requestParameters['fuelPurchaseRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FuelPurchaseFromJSON(jsonValue));
    }

    /**
     * Creates or updates a new price quote for FUEL purchase.
     */
    async updateTransactionsFuelPurchases(requestParameters: UpdateTransactionsFuelPurchasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FuelPurchase> {
        const response = await this.updateTransactionsFuelPurchasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
